var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 236.84 154.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .Hvcls-1 {\n        fill: #eaa639;\n      }\n\n      .Hvcls-2 {\n        fill: none;\n      }\n\n      .Hvcls-2, .Hvcls-3 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .Hvcls-3 {\n        fill: #023ed3;\n      }\n\n      .Hvcls-4 {\n        fill: #8c9ea8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_36",
    "data-name": "Layer 36"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-4",
    x: 21.22,
    y: 20.63,
    width: 215.12,
    height: 133.38,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-2",
    x: 21.22,
    y: 20.63,
    width: 215.12,
    height: 133.38,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_35",
    "data-name": "Layer 35"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-1",
    x: 31.38,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-2",
    x: 31.38,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_34",
    "data-name": "Layer 34"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-1",
    x: 99.69,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-2",
    x: 99.69,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_33",
    "data-name": "Layer 33"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-1",
    x: 167.17,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-2",
    x: 167.17,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_32",
    "data-name": "Layer 32"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-1",
    x: 31.79,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-2",
    x: 31.79,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_31",
    "data-name": "Layer 31"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-1",
    x: 100.11,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-2",
    x: 100.11,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_30",
    "data-name": "Layer 30"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-1",
    x: 167.59,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-2",
    x: 167.59,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_29",
    "data-name": "Layer 29"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-1",
    x: 31.79,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-2",
    x: 31.79,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_28",
    "data-name": "Layer 28"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-1",
    x: 100.11,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-2",
    x: 100.11,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_27",
    "data-name": "Layer 27"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-1",
    x: 167.59,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Hvcls-2",
    x: 167.59,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Hvcls-3",
    cx: 20.63,
    cy: 20.63,
    r: 20.13
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHive);
export default __webpack_public_path__ + "static/media/Hive.9cea61958f37fe21aafb3fa16c3ea3cd.svg";
export { ForwardRef as ReactComponent };